import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InsurancePriorityTable from './InsurancePriorityTable.js';
import InsurancePriorityModal from './InsurancePriorityModal.js';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb.js';
import paths from 'routes/paths.js';

const InsurancePriority = () => {
    const [trigger, setTrigger] = useState(0);
    const [edittrigger, setEditTrigger] = useState(0);
    const [insprval, setInsPrVal] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleOpenAddModal = () => {
        setInsPrVal(null);
        setEditTrigger(0);
        setShowModal(true);
    };

    const callAnotherChildMethod = () => {
        setTrigger((prev) => prev + 1);
    };

    const callAnotherEditChildMethod = (editValue) => {
        setInsPrVal(editValue);
        setEditTrigger((prev) => prev + 1);
        setShowModal(true);
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Patient-Insurance-Priority', href: paths.insurancePriority, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3 mt-1">
                <Col xs={12}>
                    <Card>
                        <Card.Header className="bg-body-tertiary py-2">
                            <h5 className="mb-0">Insurance Priority</h5>
                        </Card.Header>
                        <Card.Body>
                            <InsurancePriorityTable
                                trigger={trigger}
                                onCallEditParent={callAnotherEditChildMethod}
                                onOpenAddModal={handleOpenAddModal}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <InsurancePriorityModal
                show={showModal}
                onHide={() => setShowModal(false)}
                insprvalue={insprval}
                edittrigger={edittrigger}
                onCallParent={callAnotherChildMethod}
            />
        </>
    );
};

export default InsurancePriority;

